// extracted by mini-css-extract-plugin
export default {"careersContainer":"Careers_careersContainer__5sqVz","careersList":"Careers_careersList__xq458","careerCard":"Careers_careerCard__D99uf","applyButton":"Careers_applyButton__E8kOw"};